export default "__VITE_ASSET__Cqrr6elg__"